module.exports = __webpack_public_path__ + "img/Lithia.4a012bfd.png";